import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import { _get, _post } from "../../Config/axiosInstance";

function CustReg() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();

const [snackbar, setSnackbar] = useState({ open: false, message: '', varient:"filled", severity: 'success' });
 

  const onSubmit = async (data) => {
    const submitdata = {
      ...data,
      dob: data.dob ? dayjs(data.dob).format("YYYY-MM-DD") : null,
    };

    console.log("Form Data:", submitdata);
    try {
      const response = await _post(`savecustomer`, submitdata);
      if (response.data.msg.code === "SQLITE_CONSTRAINT_UNIQUE") {      
         setSnackbar({
        open: true,
        message: "Mobile Number Already Exists",
        severity: "error",
      });
      } else {
        console.log("Customer Saved", response.data.msg.code);
        setSnackbar({
        open: true,
        message: "Registration Successful!",
        severity: "success",
      });
        reset(); // clear the form
        // navigate("/dashboardpage");
        setTimeout(() => {
  navigate("/dashboardpage");
}, 2000);
      }
    } catch (error) {
      setSnackbar({
      open: true,
      message: "An error occurred while registering.",
      severity: "error",
    });
      console.log("error", error);
    }
  };


 

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: "auto",
        mt: 4,
        p: 3,
        border: "1px solid #ccc",
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" mb={3} textAlign="center">
        Customer Registration
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Stack spacing={2}>
          <TextField
            label="Full Name"
            {...register("fullName", { required: "Full name is required" })}
            error={!!errors.fullName}
            helperText={errors.fullName?.message}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <Controller
                name="dob"
                control={control}
                defaultValue={null}
                rules={{ required: "Date of Birth is required" }}
                render={({ field, fieldState }) => (
                  <DatePicker
                    label="Date of Birth"
                    views={["year", "month", "day"]}
                    value={field.value}
                    onChange={(newValue) => field.onChange(newValue)}
                    slotProps={{
                      textField: {
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message,
                        InputLabelProps: { shrink: true },
                      },
                    }}
                  />
                )}
              />
            </DemoContainer>
          </LocalizationProvider>

          <TextField
            label="Email"
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Invalid email address",
              },
            })}
            error={!!errors.email}
            helperText={errors.email?.message}
          />

          <TextField
            label="Mobile Number"
            {...register("mobile", {
              required: "Mobile number is required",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit mobile number",
              },
            })}
            error={!!errors.mobile}
            helperText={errors.mobile?.message}
          />

          <TextField
            label="Address"
            multiline
            rows={3}
            {...register("address", { required: "Address is required" })}
            error={!!errors.address}
            helperText={errors.address?.message}
          />

          <Button type="submit" variant="contained" color="primary">
            Register
          </Button>
        </Stack>
      </form>
    
      <Snackbar
  open={snackbar.open}
  autoHideDuration={3000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
>
  <Alert
    variant="filled"
    onClose={() => setSnackbar({ ...snackbar, open: false })}
    severity={snackbar.severity}
    sx={{ width: "100%" }}
  >
    {snackbar.message}
  </Alert>
</Snackbar>
      
    </Box>
  );
}

export default CustReg;
